"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var api_1 = require("./api");

var Client =
/** @class */
function (_super) {
  __extends(Client, _super);

  function Client(options) {
    var _this = _super.call(this) || this;

    _this.server = {
      emit: function emit(event, data) {
        var listeners = _this.listeners[event];

        if (listeners) {
          listeners.forEach(function (listener) {
            return listener(data);
          });
        }
      }
    };
    Object.assign(_this, options);
    window.addEventListener('message', function (_a) {
      var data = _a.data;
      return _this.socketEvent(data);
    });
    return _this;
  }
  /**
   * Emits an event to the client
   * @param event Event name
   * @param data Event data
   */


  Client.prototype.emit = function (event, data) {
    if (!window.parent) return false;
    var parsed = JSON.stringify({
      widgetbot: true,
      id: this.id,
      event: event,
      data: data
    });

    if (this.iframe.contentWindow) {
      this.iframe.contentWindow.postMessage(parsed, '*');
      return true;
    }

    return false;
  };

  return Client;
}(api_1.default);

exports.default = Client;